export interface SystemInfoServerData {
  Major: number
  Minor: number
  Build: number
  ApplyDate: string
}

export interface ActiveUser {
  DisplayToken: string
  GroupID: number
  LastAction: number
  LastActivity: number
  LoginTime: number
  Name: string
  RemoteIP: string
  UserID: number
}

export type SystemActiveUsersServerData = ActiveUser[]

export enum SystemServiceErrorCode {
  GENERAL,
}

export interface SystemInfoServiceResult {
  version: string
  date: string
}

export interface SystemKickUserServiceFailure {
  message: string
}
